import Layout from "../../components/layout";

export default function Terms() {
  return (
      <Layout>

  <div class="cookies-wrapper">

    <section class="hero">
      <div class="container">
        <h1 class="title">Cookie Policy</h1>
        <p class="subtitle">Learn how we use cookies to enhance your experience with AV technology.</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="heading">1. What Are Cookies?</h2>
        <p>Cookies are small text files stored on your device that help websites function properly and collect useful data about usage patterns.</p>
      </div>
    </section>

    <section class="section alt">
      <div class="container">
        <h2 class="heading">2. Why We Use Cookies</h2>
        <p>We use cookies to improve site performance, track engagement, and ensure smooth booking and inquiry experiences for our AV services.</p>
        <p>This includes remembering your preferences, enabling media playback, and analyzing visitor traffic to optimize our offerings.</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="heading">3. Types of Cookies We Use</h2>
        <p><strong>Essential Cookies:</strong> Necessary for basic site functionality (e.g., forms and login).</p>
        <p><strong>Analytics Cookies:</strong> Help us understand how users interact with our website (e.g., Google Analytics).</p>
        <p><strong>Media Cookies:</strong> Allow playback of videos or interactive AV content.</p>
      </div>
    </section>

    <section class="section alt">
      <div class="container">
        <h2 class="heading">4. Managing Cookies</h2>
        <p>You can manage or disable cookies through your browser settings. Disabling essential cookies may impact site functionality.</p>
        <p>We recommend allowing cookies for the best AV experience, including demo previews and booking efficiency.</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="heading">5. Contact</h2>
        <p>If you have questions about our cookie usage, email us at <a href="mailto:privacy@proslv.com">privacy@proslv.com</a>.</p>
      </div>
    </section>

  </div>

      </Layout>
  );
}
